import PropTypes from "prop-types";
import { MealPlannerHeader } from "./components/MealPlannerHeader";
import { MealPlannerWeekSelector } from "./components/MealPlannerWeekSelector";
import { MealPlannerWeekResume } from "./components/MealPlannerWeekResume";

export const MealPlanner = ({ locals }) => {
  const { mealPlan } = locals;
  const { query } = locals;
  const { viewMode } = query;

  return (
    <main role="nutrition-wrapper" className="Nutrition meal-planner-main">
      <MealPlannerHeader mealPlan={mealPlan} locals={locals} />
      {!viewMode && (
        <div className="beta-container">
          <span className="beta-text">(Beta - New Features Coming Soon)</span>
        </div>
      )}
      {!viewMode && (
        <MealPlannerWeekSelector mealPlan={mealPlan} query={locals.query} />
      )}
      <MealPlannerWeekResume mealPlan={mealPlan} locals={locals} />
    </main>
  );
};

MealPlanner.propTypes = {
  locals: PropTypes.object,
};
